import axios from 'axios'; 

import { router } from '@/main.js'

function checkResponseData(data){
	if ( isObject(data.data) ) {    
		return true;   
	}else{
		return false;
	} 
}

function isObject(val) {
	if (val === null) { return false;}
	return ( (typeof val === 'function') || (typeof val === 'object') );
}

export const actions = { 
	setLocale: (context, obj) => {
		context.commit('mutateLocale', obj.locale)
    obj.i18n.locale = obj.locale
	},
	checkUser: ( context ) => {
    return new Promise((resolve, reject) => {
			axios.get(context.getters.getApiUrl + 'sesion.php')
			.then( (respuesta) =>{  
				if( checkResponseData(respuesta.data) ){					

					if( respuesta.data.data.tipo != 'default' ){
						context.commit('mutateUserData',respuesta.data.data);
						context.commit('mutateServices',respuesta.data.data.services)

						// READ LocalStorage
						let localSrvId = JSON.parse(localStorage.getItem("selectedService"))
						//console.log('ServId: ' + localSrvId)
						//console.log(typeof localSrvId)
						if( respuesta.data.data.hasOwnProperty('services') ){
							if( respuesta.data.data.services.length == 1 ){
								// Seleccionar el único servicio disponible
								context.commit('mutateSelectedService', respuesta.data.data.services[0].srv_id)
							}else{
								let srvFound = respuesta.data.data.services.findIndex( element => element.srv_id == localSrvId )
								//console.log('Found: ' + srvFound )
								// Si no existe el localService en el listado lo reseteamos
								if( srvFound == -1 ){
									context.commit('mutateSelectedService', 0 )
								}
							}
						}else{
							context.commit('mutateSelectedService', 0 )
						}
					}					

					//context.commit('mutateUserData', {"identidad":"[Sender Identity]","nombre":"John Doe","tipo":"procure"})
					resolve(true)
				}else{
					context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message: respuesta.data } )
				}  
			})  
			.catch( (error) =>{ 
				let  message = '';
				if (error.response.data.hasOwnProperty('message')) {
					message = error.response.data.message;
				}else{
					message = error
				}
				context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message:   message } )	
			})   
    })
  },
	loadShoppingCart: ( context ) => { 
		context.commit('mutateShoppingCartLoading', true);
		axios.get(context.getters.getApiUrl + 'carrito.php', { withCredentials: true })
		.then( (respuesta) =>{  
			if( checkResponseData(respuesta.data) ){
				context.commit('mutatePunchOutUrl', respuesta.data.punchOutURL);
				context.commit('mutateShoppingCart',respuesta.data.data);
			}else{
				context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message: respuesta.data } )
			}  
			context.commit('mutateShoppingCartLoading', false);
		})  
		.catch( (error) =>{ 
			let  message = '';
			if (error.response.data.hasOwnProperty('message')) {
				message = error.response.data.message;
			}else{
				message = error
			}
			context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message:   message } )	
			context.commit('mutateShoppingCartLoading', false);
		})    
	},
	addItemShoppingCart: ( context, item ) => {
		context.commit('mutateShoppingCartLoading', true);

		// Read Line
		// item.lin_id
		//let linId = router.currentRoute.params.lin.substr(0,router.currentRoute.params.lin.indexOf("-"))
		//console.log(item.lin_id)

		return new Promise((resolve, reject) => {

			axios.post(context.getters.getApiUrl + 'carrito.php', { ref_number: item.ref_number, ref_quantity: item.updateValue, lin_id: item.lin_id } )
			.then( (respuesta) =>{  
				if( checkResponseData(respuesta.data) ){
					
					context.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: 'Ok', message: respuesta.data.message } )

					item.updateValue = 0;

					// Load new Shopping Cart
					context.dispatch('loadShoppingCart')

				}else{
					context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message: respuesta.data } )
					resolve(false) 
				}  
				context.commit('mutateShoppingCartLoading', false);
				resolve(true)
			})  
			.catch( (error) =>{ 
				let  message = '';
				if (error.response.data.hasOwnProperty('message')) {
					message = error.response.data.message;
				}else{
					message = error
				}
				context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message:   message } )	
				context.commit('mutateShoppingCartLoading', false);
				resolve(false)
			})   	
		})
	},
	updateItemShoppingCart: ( context, item ) => {
		context.commit('mutateShoppingCartLoading', true);

		axios.put(context.getters.getApiUrl + 'carrito.php', { ref_number: item.ref_number, ref_quantity: item.updateValue} )
		.then( (respuesta) =>{  
			if( checkResponseData(respuesta.data) ){
				
				context.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: 'Ok', message: respuesta.data.message } )

				item.updateValue = 0;

				// Load new Shopping Cart
				context.dispatch('loadShoppingCart')

			}else{
				context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message: respuesta.data } )
			}  
			context.commit('mutateShoppingCartLoading', false);
		})  
		.catch( (error) =>{ 
			let  message = '';
			if (error.response.data.hasOwnProperty('message')) {
				message = error.response.data.message;
			}else{
				message = error
			}
			context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message:   message } )	
			context.commit('mutateShoppingCartLoading', false);
		}) 

		/* let tmpCart = [];
		let tmpItem = {};

		item.ref_quantity = item.updateValue;
		item.updateValue = 0;

		let index = context.state.shoppingCart.findIndex( (elm) => elm.ref_number == item.ref_number  )
		Object.assign(tmpCart,context.state.shoppingCart);
		Object.assign(tmpItem,item);
		tmpItem.editing = false;
		tmpCart.splice(index, 1, tmpItem);

		context.commit('mutateShoppingCart', tmpCart)
		context.commit('mutateShoppingCartLoading', false); */
	},
	deleteItemShoppingCart: ( context, item ) => {
		context.commit('mutateShoppingCartLoading', true);
		axios.delete(context.getters.getApiUrl + 'carrito.php', { data: item })
		.then( (respuesta) =>{  
			if( checkResponseData(respuesta.data) ){
			
				context.commit('mutateGlobalMessage', { toast: true, icon: 'success', title: 'Ok', message: respuesta.data.message } )

				// Load new Shopping Cart
				context.dispatch('loadShoppingCart')

			}else{
				context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message: respuesta.data } )
			}  
			context.commit('mutateShoppingCartLoading', false);
		})  
		.catch( (error) =>{ 
			let  message = '';
			if (error.response.data.hasOwnProperty('message')) {
				message = error.response.data.message;
			}else{
				message = error
			}
			context.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: 'Error', message:   message } )	
			context.commit('mutateShoppingCartLoading', false);
		})  
		context.commit('mutateShoppingCartLoading', false);	
	},
	punchOutShoppingCart: ( context, item ) => {
		// Axios punchOut
		// result = shoppingCart
	},

};
